import { SxProps, Theme, Link } from '@mui/material';
import { useDownloadPdfFiles } from 'shared/mutations/pdf-download-mutation';
import { addPdfExtension } from 'shared/utility';
import { UseTableCellProps } from 'react-table';
import { IAdditionalQuoteDocumentationItem } from 'shared/types';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
  cursor: 'pointer',
};

export function QuoteDownloadFileColumn({
  value,
  row: {
    original: { id },
  },
}: UseTableCellProps<IAdditionalQuoteDocumentationItem>) {
  const pdfDownloadMutation = useDownloadPdfFiles();
  return (
    <Link
      sx={gridStyles}
      variant='body2'
      onClick={async () => {
        await pdfDownloadMutation.mutateAsync({
          fileId: !!id ? addPdfExtension(id) : '',
          originalFileName: value,
        });
      }}
    >
      {value}
    </Link>
  );
}
